import * as React from 'react';
import Svg, { G, Rect } from 'react-native-svg';
const IconMenu = (props) => (
  <Svg xmlns="http://www.w3.org/2000/svg" width={34} height={24} {...props}>
    <G fill="#fff" transform="translate(-1171 -110)">
      <Rect width={32} height={4} rx={2} transform="translate(1171 110)" />
      <Rect width={32} height={4} rx={2} transform="translate(1171 120)" />
      <Rect width={32} height={4} rx={2} transform="translate(1171 130)" />
    </G>
  </Svg>
);
export default IconMenu;
